import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BodyComponent } from '@design-system/typography/body/body.component';

/**
 * Component that displays a cookie consent banner message
 */
@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, BodyComponent]
})
export class CookieConsentBannerComponent {}
